module.exports = __webpack_public_path__ + "img/4.b6c93aa3.jpg";